import React, { ForwardedRef } from 'react';
import { ButtonTabBase } from './ButtonTabBase';
import { TabProps } from '../TabsProps';

export const ButtonNavTab = React.forwardRef(function ButtonNavTab(
  props: TabProps,
  ref: ForwardedRef<HTMLAnchorElement | HTMLDivElement>
): JSX.Element {
  return (
    <ButtonTabBase ref={ref} {...props}>
      {props.children}
    </ButtonTabBase>
  );
});
